<template>
  <div>
    <wc-data-box
      :title='$store.state.icons.dataBox.overdueActions.title'
      :titleIcon='$store.state.icons.dataBox.overdueActions.icon'
      :titleIconColor='$store.state.icons.dataBox.overdueActions.iconColor'
    >
      <v-card-text>
        <v-tooltip top>
          <template v-slot:activator='{ on }'>
            <v-btn
              :disabled='invoice.archived || invoice.is_uncollectible'
              small
              v-model='invoice.action_1'
              :outlined='!invoice.action_1'
              :depressed='invoice.action_1'
              color='error'
              v-on='on'
              class='mr-3'
              @click='a1'
            >
              Action 1
            </v-btn>
          </template>
          <span>Email or phone</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator='{ on }'>
            <v-btn
              :disabled='invoice.archived || invoice.is_uncollectible'
              @click='a2'
              small
              v-model='invoice.action_2'
              :outlined='!invoice.action_2'
              :depressed='invoice.action_2'
              color='error'
              v-on='on'
              class='mr-3'
            >
              Action 2
            </v-btn>
          </template>
          <span>Phone call</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator='{ on }'>
            <v-btn
              :disabled='invoice.archived || invoice.is_uncollectible'
              @click='a3'
              small
              v-model='invoice.action_3'
              :outlined='!invoice.action_3'
              :depressed='invoice.action_3'
              color='error'
              v-on='on'
              class='mr-3'
            >
              Action 3
            </v-btn>
          </template>
          <span>Phone call</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator='{ on }'>
            <v-btn
              :disabled='invoice.archived || invoice.is_uncollectible'
              @click='a4'
              small
              v-model='invoice.action_4'
              :outlined='!invoice.action_4'
              :depressed='invoice.action_4'
              color='error'
              v-on='on'
              class='mr-3'
            >
              Action 4
            </v-btn>
          </template>
          <span>Arrears letter sent</span>
        </v-tooltip>
      </v-card-text>
    </wc-data-box>
  </div>
</template>

<script>
import moment from 'moment';
import trackerAPI from '@/api/tracker';

export default {
  name: 'invoice-overdue-actions',
  props: {
    invoice: {
      required: true
    }
  },
  data: () => ({
    isLoading: true
  }),
  methods: {
    async a1 () {
      if (!this.invoice.action_2) {
        const invoice_action = !this.invoice.action_1;
        this.invoice.action_1 = invoice_action;
        if (this.invoice.action_1) {
          await this.newAction('Took action 1');
        } else {
          await this.newAction('UN-did action 1');       
        }
        this.updateActions({"action_1": invoice_action});
      }
    },
    async a2 () {
      if (this.invoice.action_1 && !this.invoice.action_3) {
        const invoice_action = !this.invoice.action_2;
        this.invoice.action_2 = invoice_action;
        if (this.invoice.action_2) {
          await this.newAction('Took action 2');
        } else {
          await this.newAction('UN-did action 2');       
        }
        this.updateActions({"action_2": invoice_action});
      }
    },
    async a3 () {
      if (this.invoice.action_2 && !this.invoice.action_4) {
        const invoice_action = !this.invoice.action_3;
        this.invoice.action_3 = invoice_action;
        if (this.invoice.action_3) {
          await this.newAction('Took action 3');
        } else {
          await this.newAction('UN-did action 3');       
        }
        this.updateActions({"action_3": invoice_action});
      }
    },
    async a4 () {
      if (this.invoice.action_3) {
        const invoice_action = !this.invoice.action_4;
        this.invoice.action_4 = invoice_action;
        if (this.invoice.action_4) {
          await this.newAction('Took action 4')
        } else {
          await this.newAction('UN-did action 4') 
        }
        this.updateActions({"action_4": invoice_action});
      }
    },
    updateActions (update) {
      this.$emit('update', this.invoice.id, update);
    },
    async newAction (action) {
      const tracker_data = {
            'description': action,
            'taken_by': this.$store.state.auth.profile.id,
            'action_date': moment().format('YYYY-MM-DD').toString()
        }
        const tracker = {
            'tracker_data': tracker_data,
            'invoice': this.invoice.id
        }
      const res = await trackerAPI.createInvoiceTracker(tracker);
      this.$emit('newAction', res);
    }
  }
}
</script>
